import React, {Component} from "react";
import {connect} from "react-redux";
import wave1 from "../../images/wave1.png"
import wave2 from "../../images/wave2.png"
import wave3 from "../../images/wave3.png"
import pencil from "../../images/pencil.gif"
import contactUs from "../../images/contact.png"
import logo from "../../images/logo-white.png"
import {history} from "../../history/History";
import FooterLanding from "./FooterLanding";

class Home extends Component {

    constructor(props) {
        super(props)

        this.state = {
            scrollY: 0,
            mobileHeaderOpenStatus: 0,
            heightStyle: undefined
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = (event) => {
        this.setState({
            scrollY: window.scrollY
        })
    }

    toggleMobileMenu = () => {
        let status = this.state.mobileHeaderOpenStatus;
        this.setState({
            mobileHeaderOpenStatus: status === 2 ? 0 : 2
        });
    }

    gotoSumMenu = (id) => {
        document.getElementById(id).scrollIntoView({
            behavior: 'smooth'
        })
        if (this.state.mobileHeaderOpenStatus === 2)
            this.setState({
                mobileHeaderOpenStatus: 0
            });
    }

    render() {
        return (
            <div className="landing-body">
                <header className={"ReactStickyHeader_root " + (this.state.scrollY === 0 ? "" : "is-sticky")}>
                    <div className="ReactStickyHeader_fixed">
                        <nav className="navbar-custom sticky sticky-dark  navbar navbar-expand-lg fixed-top">
                            <div className="container">
                                <img src={logo} alt="" className="logo-landing"/>
                                <a href="/"
                                   className="logo text-uppercase navbar-brand white-text">Tutorfest
                                </a>
                                <button
                                    onClick={this.toggleMobileMenu}
                                    aria-label="Toggle navigation"
                                    className="navbar-toggler">
                                    <i className="icon-menu"/>
                                </button>
                                <div id="navbarCollapse"
                                     className={(this.state.mobileHeaderOpenStatus === 0 ?
                                         "collapse" : (this.state.mobileHeaderOpenStatus === 1 ?
                                             "collapsing" : "collapse show")) + " navbar-collapse"}
                                     style={this.state.heightStyle ? {height: this.state.heightStyle + 'px'} : {}}
                                >
                                    <div data-nav="list" className="navbar-collapse">
                                        <ul id="mySidenav" className="navbar-center navbar-nav">
                                            <li className="nav-item active">
                                                <button
                                                    onClick={() => this.gotoSumMenu("home")}
                                                    className="header-item nav-link active"> Home
                                                </button>
                                            </li>

                                            <li className="nav-item active">
                                                <button
                                                    onClick={() => this.gotoSumMenu("features")}
                                                    className="header-item nav-link active"> Features
                                                </button>
                                            </li>
                                            <li className="nav-item active">
                                                <button
                                                    onClick={() => this.gotoSumMenu("contact")}
                                                    className="header-item nav-link active"> Contact
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="nav-button ms-auto">
                                            <ul className="navbar-end navbar-nav text-left">
                                                <li>
                                                    <button onClick={() => history.push("/hom/login")}
                                                            className="btn mr-2 btn-primary pink navbar-btn btn-rounded waves-effect waves-light ">
                                                        Login
                                                    </button>
                                                </li>
                                                <li className="show-desktop">
                                                    <button onClick={() => history.push("/hom/register")}
                                                            className="btn btn-primary navbar-btn btn-rounded waves-effect waves-light black-text">
                                                        Sign Up
                                                    </button>
                                                </li>
                                                <li className="show-mobile mt-3">
                                                    <button onClick={() => history.push("/hom/register")}
                                                            className="btn btn-primary navbar-btn btn-rounded waves-effect waves-light black-text">
                                                        Sign Up
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                    <div className="ReactStickyHeader_midground" style={{height: 0, top: 0}}/>
                    <div className="ReactStickyHeader_background-bg"/>
                    <div className="ReactStickyHeader_foreground" style={{opacity: this.state.scrollY === 0 ? 1 : 0}}/>
                </header>
                <section className="section bg-home home-half" id="home" data-image-src="images/bg-home.jpg">
                    <div className="bg-overlay"/>
                    <div className="display-table">
                        <div className="display-table-cell">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-2"/>
                                    <div className="col-sm-8 text-white text-center ">
                                        <h1 className="home-title">Lorem ipsum dolor sit amet!</h1>
                                        <p className="pt-3 home-desc">Lorem ipsum dolor sit amet, consectetur adipiscing
                                            elit, sed do eiusmod tempor, sed do eiusmod tempor
                                        </p>
                                        <p className="play-shadow mt-4">
                                            <a href="/hom" target="_blank"  rel="noopener noreferrer" className="btn btn-primary btn-rounded">
                                                Go to app
                                            </a>
                                        </p>
                                    </div>
                                    <div className="col-sm-2"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wave-effect wave-anim">
                        <div className="waves-shape shape-one">
                            <div className="wave wave-one"
                                 style={{backgroundImage: 'url(' + wave1 + ')'}}/>
                        </div>
                        <div className="waves-shape shape-two">
                            <div className="wave wave-two"
                                 style={{backgroundImage: 'url(' + wave2 + ')'}}/>
                        </div>
                        <div className="waves-shape shape-three">
                            <div className="wave wave-three"
                                 style={{backgroundImage: 'url(' + wave3 + ')'}}/>
                        </div>
                    </div>
                </section>
                <section className="section pt-5" id="features">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-2"/>
                            <div className="col-sm-8">
                                <h1 className="section-title text-center">Loren ipsum</h1>
                                <div className="section-title-border mt-3"/>
                                <p className="section-subtitle text-muted text-center pt-4 font-secondary">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                </p>
                            </div>
                            <div className="col-sm-2"/>
                        </div>
                        <div className="mt-4 row">
                            <div className="mt-3 col-lg-4">
                                <div className="services-box text-center hover-effect">
                                    <i className="icon-star"/><h4 className="pt-3">Loren ipsum</h4>
                                    <p className="pt-3 text-muted">Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                            <div className="mt-3 col-lg-4">
                                <div className="services-box text-center hover-effect">
                                    <i className="icon-verified_user"/><h4 className="pt-3">Loren ipsum</h4>
                                    <p className="pt-3 text-muted">Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                            <div className="mt-3 col-lg-4">
                                <div className="services-box text-center hover-effect">
                                    <i className="icon-search pl-2"/><h4 className="pt-3">Loren ipsum</h4>
                                    <p className="pt-3 text-muted">Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section bg-light-landing">
                    <div className="container">
                        <div className="vertical-content row">
                            <div className="col-lg-5">
                                <div className="features-box"><h3>Lorem ipsum dolor sit amet, consectetur adipiscing
                                    elit, sed do eiusmod tempor incididunt</h3>
                                    <p className="text-muted web-desc">Lorem ipsum dolor sit amet, consectetur
                                        adipiscing
                                        elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                    <ul className="text-muted list-unstyled mt-4 features-item-list">
                                        <li className="">Feature 1</li>
                                        <li className="">Feature 2</li>
                                        <li className="">Feature 3</li>
                                        <li className="">Feature 4</li>
                                    </ul>
                                    <a className="btn btn-primary btn-rounded d-flex justify-content-center align-items-center w-50"
                                       href="/hom/login" target="_blank"  rel="noopener noreferrer">
                                        <span className="mr-2">Request Now</span>
                                        <i className="icon-keyboard_arrow_right"/></a></div>
                            </div>
                            <div className="col-lg-7">
                                <div className="features-img features-right text-right">
                                    <img src={pencil} alt="pencil" className="img-fluid"/></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section " id="contact">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-2"/>
                            <div className="col-lg-8 offset-lg-2"><h1 className="section-title text-center">GET IN
                                TOUCH</h1>
                                <div className="section-title-border mt-3"/>
                                <p className="section-subtitle text-muted text-center pt-4 font-secondary">Lorem ipsum
                                    dolor sit amet, consectetur
                                    adipiscing
                                    elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p></div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="mt-4 pt-4">
                                    <p className="mt-4">
                                        <span className="h5">Office Address 1:</span><br/>
                                        <span
                                            className="text-muted d-block mt-2">4353 Example Street Example, CO 72368</span>
                                    </p>
                                    <p
                                        className="mt-4">
                                        <span className="h5">Office Address 2:</span>
                                        <br/>
                                        <span className="text-muted d-block mt-2">4353 Example Street Example <br/>
                                        New Orleans, LA 50001</span>
                                    </p>
                                    <p className="mt-4">
                                        <span className="h5">Working Hours:</span>
                                        <br/>
                                        <span className="text-muted d-block mt-2">9:00AM To 6:00PM</span>
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="custom-form mt-4 pt-4">
                                    <div className="features-img features-right text-center">
                                        <img style={{maxWidth: '380px'}} src={contactUs} alt="contact us"
                                             className="img-fluid"/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="contact-social bg-light">
                    <div className="container">
                        <div className="align-items-center row">
                            <div className="col-lg-6">
                                <ul className="list-inline social mt-4">
                                    <li className="list-inline-item">
                                        <a className="social-icon" href="https://facebook.com" target="_blank"
                                           rel="noopener noreferrer">
                                            <i className="icon-facebook"/>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="social-icon" href="https://twitter.com" target="_blank"
                                            rel="noopener noreferrer">
                                            <i className="icon-twitter"/>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="ml-2 social-icon" href="https://instagram.com" target="_blank"
                                            rel="noopener noreferrer">
                                            <i className="icon-instagram"/>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="mt-2 col-lg-3">
                                <a href="tel:+911234556789" className="contact-title">
                                    <i className="icon-phone"/> &nbsp;+91 123 4556 789
                                </a>
                            </div>
                            <div className="mt-2 text-left col-lg-3">
                                <a href="mailto:support@tutorfest.com" className="contact-title">
                                    <i className="icon-envelope"/>&nbsp; Support@tutorfest.com
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <FooterLanding/>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
